import { DOWNLOAD_FILES_QUERY } from './download-files.query';
import { graphql } from '../gql';
import { useMutation } from '@apollo/client';

const CLAIM_CREATE_COVERAGE_LETTER_MUTATION = graphql(`
  mutation createClaimCoverageLetter($claimUuid: String!) {
    createClaimCoverageLetter(claimUuid: $claimUuid) {
      result
      savedDocuments
      folder
    }
  }
`);

export function useCreateCoverageLetterMutation() {
  const [claimCreateCoverageLetter, { data, loading, error, reset }] =
    useMutation(CLAIM_CREATE_COVERAGE_LETTER_MUTATION, {
      refetchQueries: [DOWNLOAD_FILES_QUERY],
      awaitRefetchQueries: true,
    });
  return {
    data,
    claimCreateCoverageLetter,
    loading,
    error,
    reset,
  };
}
